import React from "react";
import { DataGridPro, LicenseInfo } from "@mui/x-data-grid-pro";
import NoDataFound from "../nodatafound/NoDataFound";
import { makeStyles } from "@material-ui/core/styles/";
import { theme } from "../../views/App";
import { Box, Stack } from "@mui/material";
import PaginationUI from "../pagination/Pagination";

LicenseInfo.setLicenseKey(
  "b3797b650a3bd36f98c3dc7a00e5f266Tz00OTk4NyxFPTE2OTM0NzQ3NDQ4NzQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);

function DataGridFunction({
  columns,
  rows,
  rowReordering,
  pagination,
  rowHeight,
  getRowHeight,
  onCellClick,
  checkboxSelection,
  curser,
  getRowId,
  onSelectionModelChange,
  apiRef,
  onRowClick,
  pagelength,
  onRowOrderChange,
  page,
  handleChange,
  height,
  selectionModel,
}) {
  const useStyles = makeStyles({
    root: {
      "& .MuiDataGrid-cellCenter": {
        justifyContent: "center",
        display: "none",
      },
      // header background color
      "& .css-1oi61yq-MuiDataGrid-columnHeaders": {
        backgroundColor: theme.palette.datagrid.background.datagridHeader,
        color: theme.palette.primary.main,
      },
      // " .MuiDataGrid-columnHeader .MuiDataGrid-columnHeader--sortable": {},
      // "& .MuiDataGrid-main": { borderRadius: 0 },
      "& .MuiDataGrid-columnHeaders": {
        fontSize: theme.palette.datagrid.Columns.fontSize,
      },
      // row background color
      // "& .MuiDataGrid-cell": {
      //   backgroundColor: theme.palette.datagrid.background.datagridCell,
      // },
      "& .MuiDataGrid-row": {
        backgroundColor: theme.palette.datagrid.background.datagridCell,

        "&:hover": {
          backgroundColor: theme.palette.datagrid.background.hover,
          cursor: curser === "pointer" ? "pointer" : "default",
        },
      },
    },
  });
  const classes = useStyles();

  return (
    //*******************************************  Datagrid components
    <Box
      sx={{
        paddingTop: 1,
        height: rows.length === 0 ? "15vh" : height ? height : "80vh",
        width: "100%",
      }}
    >
      <DataGridPro
        components={{
          NoRowsOverlay: () => <NoDataFound />,
          Footer: () =>
            pagelength ? (
              <PaginationUI
                pagelength={pagelength}
                page={page}
                handleChange={handleChange}
              />
            ) : null,
        }}
        componentsProps={{
          pagination: pagination,
        }}
        onRowOrderChange={onRowOrderChange}
        rowReordering={rowReordering}
        className={classes.root}
        density="compact"
        rowHeight={rowHeight}
        rows={rows}
        getRowHeight={getRowHeight}
        onCellClick={onCellClick}
        getRowId={getRowId ? getRowId : (rows) => rows.id}
        columns={columns}
        checkboxSelection={checkboxSelection}
        selectionModel={selectionModel}
        disableSelectionOnClick
        onRowClick={onRowClick}
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: theme.palette.buttonComponent.fontSize.extraLarge,
            fontWeight: theme.typography.fontWeightBold,
          },
          fontSize: theme.palette.buttonComponent.fontSize.large,
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "red",
          },
        }}
        hideFooterPagination={true}
        onSelectionModelChange={onSelectionModelChange}
        apiRef={apiRef}
        //   pageSize={pageSize}
        //   onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        //   rowsPerPageOptions={[5, 10, 20]}
        //   pagination
      />
    </Box>
  );
}

export default DataGridFunction;
